import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LayoutDashboard, FileText, Receipt, Users, Settings as SettingsIcon, LogOut, Crown, Hammer } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Toaster } from "../components/ui/sonner";
import LanguageSwitcher from "../components/LanguageSwitcher";

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navItems = [
    { to: "/app", icon: LayoutDashboard, label: t("nav.overview"), end: true, testid: "nav-overview" },
    { to: "/app/presupuestos", icon: FileText, label: t("nav.estimates"), testid: "nav-estimates" },
    { to: "/app/facturas", icon: Receipt, label: t("nav.invoices"), testid: "nav-invoices" },
    { to: "/app/obras", icon: Hammer, label: t("nav.projects"), testid: "nav-projects" },
    { to: "/app/clientes", icon: Users, label: t("nav.clients"), testid: "nav-clients" },
    { to: "/app/planes", icon: Crown, label: t("nav.plans"), testid: "nav-plans" },
    { to: "/app/configuracion", icon: SettingsIcon, label: t("nav.settings"), testid: "nav-settings" },
  ];

  return (
    <div className="min-h-screen bg-surface-base text-white flex">
      <aside className="w-64 fixed h-screen bg-[#0A1128] border-r border-white/10 flex flex-col" data-testid="sidebar">
        <Link to="/app" className="px-6 py-6 border-b border-white/10 block">
          <div className="font-display font-black text-2xl">
            <span className="text-gradient-vel7o">Vel7o</span>
            <span className="text-white">.com</span>
          </div>
        </Link>
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map(({ to, icon: Icon, label, end, testid }) => (
            <NavLink key={to} to={to} end={end} data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md transition-all duration-200 text-sm ${
                  isActive ? "bg-brand-cyan/10 text-brand-cyan border border-brand-cyan/30" : "text-white/70 hover:bg-white/5 hover:text-white"
                }`
              }>
              <Icon className="w-4 h-4" strokeWidth={1.5} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-3">
          <LanguageSwitcher />
          <div className="text-xs text-white/50 truncate flex items-center gap-1">
            {user?.is_pro && <Crown className="w-3 h-3 text-brand-orange" />}
            {user?.email}
          </div>
          <Button
            data-testid="logout-btn"
            variant="ghost"
            className="w-full justify-start text-white/70 hover:text-white hover:bg-white/5"
            onClick={() => { logout(); navigate("/"); }}>
            <LogOut className="w-4 h-4 mr-2" strokeWidth={1.5} /> {t("common.logout")}
          </Button>
        </div>
      </aside>

      <main className="ml-64 flex-1 min-h-screen">
        <div className="p-8 max-w-7xl">
          <Outlet />
        </div>
      </main>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}
